/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlenderTownVm
 */
export interface SlenderTownVm {
    /**
     * 
     * @type {string}
     * @memberof SlenderTownVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SlenderTownVm
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SlenderTownVm
     */
    isActivated?: boolean;
}

export function SlenderTownVmFromJSON(json: any): SlenderTownVm {
    return SlenderTownVmFromJSONTyped(json, false);
}

export function SlenderTownVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlenderTownVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isActivated': !exists(json, 'isActivated') ? undefined : json['isActivated'],
    };
}

export function SlenderTownVmToJSON(value?: SlenderTownVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'isActivated': value.isActivated,
    };
}


